module.exports = __webpack_public_path__ + "img/37.742ea67d.png";